import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { api } from 'app/api'
import { GET_EMPLOYEES_LIST, convertParams, convertResult } from 'app/common/api/requests/food/employees/get'
import { EmployeeListType } from 'app/dataTypes/employeesList'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { orgsFilterSelection } from './orgsFilter'


type EmployeeList = Array<ItemType>

class EmployeeListFilterDataBox extends DataBox<EmployeeList> { }

export const defaultEmployeeList: EmployeeList = []
export const employeeListFilter = createDataBox('employeeListFilter', defaultEmployeeList, EmployeeListFilterDataBox)


const convertFromExtended = (employeeList: EmployeeListType): EmployeeList => {
  return employeeList.map(({ id, name }) => {
    const title = Object.values(name).join(' ')
    return ({ id, title })
  })
}


export const defaultEmployeeListDataReceiver = async () => {
  const orgIds = orgsFilterSelection.getData()
  const orgId = orgIds[0]

  const res = await api.request(GET_EMPLOYEES_LIST, {
    error: 'Не удалось получить данные классов',
    params: {
      schoolId: orgId,
    },
    convertions: {
      convertParams,
      convertResult,
    },
  })
  return res ? convertFromExtended(res.employees) : []
}

export const defaultEmployeeListSelection: Array<string> = []
export const employeeListFilterSelection = createDataBoxDefault<Array<string>>('employeeListFilterSelection', defaultEmployeeListSelection)
